import type { UpdateNotificationSettingsBodyDeliverySettings } from './updateNotificationSettingsBodyDeliverySettings';
import type { UpdateNotificationSettingsBodyTypeSettings } from './updateNotificationSettingsBodyTypeSettings';

/**
 * 알림 설정 업데이트 요청
 */
export type UpdateNotificationSettingsBody = {
  /** 알림 전달 설정 */
  deliverySettings?: UpdateNotificationSettingsBodyDeliverySettings;
  /** 알림 유형별 설정 */
  typeSettings?: UpdateNotificationSettingsBodyTypeSettings;
};
